// src/main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app/app.routes';
import { environment } from './environments/environments.commons';

const config = {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideRouter(routes, ...(environment.useHash ? [withHashLocation()] : [])),
  ],
};

bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
